import type { FaireProductEntity } from "../../entity_types/product";

export const p_gqmbkutm8u: FaireProductEntity = {
  token: "p_gqmbkutm8u",
  type: "product",
  name: "Rose Gold Deer Sphere Stand",
  brandToken: "b_ciwhgi8nfq",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/b6a7b41a10231847d79263b6c3339b47076143805ecbf909bfa53411cafd108d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/48a79182767dde66dc0c72429dde9b6c4a51a93ec61ef2d70ccc1eda693c0fae.jpeg",
    "https://cdn.faire.com/fastly/5f53278799396a702e37dd77de1efeb47af954d01b34ce38fd100b63d78850c2.jpeg",
  ],
  priceDollars: 6,
  description:
    '\nThis listing is for ONE Rose Gold Deer Sphere Stand\n\nSize: approximately 2.75"\n\nCan hold spheres up to 2” diameter\n\nSphere shown in photo is SOLD SEPARATELY \n\nSHIPPING CALCULATED AFTER CHECKOUT\n',
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:44.841Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
